// extracted by mini-css-extract-plugin
export default {"icon":"CloseIcon_icon__8UuBV"};